import { MultiSelectOption } from 'ui/atoms/MultiSelect/typings'

const rectificationOptions: MultiSelectOption[] = [
  {
    value: 'consumer',
    englishLabel: 'Consumer',
    spanishLabel: 'Consumidor',
    dataReason: '1'
  },
  {
    value: 'customerName',
    englishLabel: 'Consumer Name',
    spanishLabel: 'Nombre del Consumidor',
    dataReason: '2'
  },
  {
    value: 'beneficiary',
    englishLabel: 'Beneficiary',
    spanishLabel: 'Beneficiario',
    dataReason: '3'
  },
  {
    value: 'emergencyContact',
    englishLabel: 'Emergency Contact',
    spanishLabel: 'Contacto de Emergencia',
    dataReason: '4'
  },
  {
    value: 'jointAccountHolder',
    englishLabel: 'Joint Account Holder',
    spanishLabel: ' Titular Conjunto de la Cuenta',
    dataReason: '5'
  },
  {
    value: 'dateOfBirth',
    englishLabel: 'Date Of Birth',
    spanishLabel: 'Fecha de Nacimiento',
    dataReason: '6'
  },
  {
    value: 'firstName',
    englishLabel: 'First Name',
    spanishLabel: 'Primer Nombre',
    dataReason: '7'
  },
  {
    value: 'middleName',
    englishLabel: 'Middle Name',
    spanishLabel: 'Segundo Nombre',
    dataReason: '8'
  },
  {
    value: 'surName',
    englishLabel: 'Surname',
    spanishLabel: 'Apellido',
    dataReason: '9'
  },
  {
    value: 'patientName',
    englishLabel: 'Patient Name',
    spanishLabel: 'Nombre del Paciente',
    dataReason: '10'
  },
  {
    value: 'customerMobilePhoneNumber',
    englishLabel: 'Customer Mobile Phone Number',
    spanishLabel: 'Número de Teléfono Celular del Cliente',
    dataReason: '11'
  },
  {
    value: 'emailAddress',
    englishLabel: 'Email Address',
    spanishLabel: 'Dirección de Correo Electrónico',
    dataReason: '12'
  },
  {
    value: 'homeAddress',
    englishLabel: 'Home Address',
    spanishLabel: 'Domicilio',
    dataReason: '13'
  },
  {
    value: 'mailingAddress',
    englishLabel: 'Mailing Address',
    spanishLabel: 'Dirección Postal',
    dataReason: '14'
  },
  {
    value: 'phoneNumber',
    englishLabel: 'Phone Number',
    spanishLabel: 'Número de Teléfono',
    dataReason: '15'
  },
  {
    value: 'primaryPhoneNumber',
    englishLabel: 'Primary Phone Number',
    spanishLabel: 'Número de Teléfono Principal',
    dataReason: '16'
  },
  {
    value: 'residenceCode',
    englishLabel: 'Residence Code',
    spanishLabel: 'Código de Residencia',
    dataReason: '17'
  },
  {
    value: 'secondaryPhoneNumber',
    englishLabel: 'Secondary Phone Number',
    spanishLabel: 'Número de Teléfono Secundario',
    dataReason: '18'
  },
  {
    value: 'postalCode',
    englishLabel: 'Postal Code',
    spanishLabel: 'Código Postal',
    dataReason: '19'
  },
  {
    value: 'faxNumber',
    englishLabel: 'Fax Number',
    spanishLabel: 'Número de Fax',
    dataReason: '20'
  },
  {
    value: 'patientFaxNumber',
    englishLabel: 'Patient Fax Number',
    spanishLabel: 'Número de Fax del Paciente',
    dataReason: '21'
  },
  {
    value: 'providerFaxNumber',
    englishLabel: 'Provider Fax Number',
    spanishLabel: 'Número de Fax del Proveedor',
    dataReason: '22'
  },
  {
    value: 'patientAddress',
    englishLabel: 'Patient Address',
    spanishLabel: 'Dirección del Paciente',
    dataReason: '23'
  },
  {
    value: 'providerAddress',
    englishLabel: 'Provider Address',
    spanishLabel: 'Dirección del Proveedor',
    dataReason: '24'
  },
  {
    value: 'patientEmailAddress',
    englishLabel: 'Patient Email Address',
    spanishLabel: 'Dirección de Correo Electrónico del Paciente',
    dataReason: '25'
  },
  {
    value: 'providerPhoneNumber',
    englishLabel: 'Provider Phone Number',
    spanishLabel: 'Número de Teléfono del Proveedor',
    dataReason: '26'
  },
  {
    value: 'employerIdentificationNumber',
    englishLabel: 'Employer Identification Number',
    spanishLabel: 'Número de Identificación del Empleador',
    dataReason: '27'
  },
  {
    value: 'socialSecurityNumber',
    englishLabel: 'Social Security Number',
    spanishLabel: 'Número de Seguro Social',
    dataReason: '28'
  },
  {
    value: 'taxpayerIdentificationNumber',
    englishLabel: 'Taxpayer Identification Number',
    spanishLabel: 'Número de Identificación Fiscal',
    dataReason: '29'
  },
  {
    value: 'employerName',
    englishLabel: 'Employer Name',
    spanishLabel: 'Nombre del Empleador',
    dataReason: '30'
  },
  {
    value: 'employerPostalCode',
    englishLabel: 'Employer Postal Code',
    spanishLabel: 'Código Postal del Empleador',
    dataReason: '31'
  },
  {
    value: 'employerAddress',
    englishLabel: 'Employer Address',
    spanishLabel: 'Dirección del Empleador',
    dataReason: '32'
  }
]

export default rectificationOptions
